document.addEventListener("DOMContentLoaded", async () => {
    let container = document.querySelector("#color-selector");
    if (!container) return;
    if (container.isRendered) return;
    container.isRendered = true;
    let fetchRes = await fetch(`https://distribucion-sync.mimao.eu/html?shop_path_name=${window.location.pathname}&sku=${container.dataset.sku}`);
    let body     = await fetchRes.text();
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(body, 'text/html');
    container.appendChild(htmlDoc.querySelector("#parsed-html"));
    linkDynamicFlexOverflows();
});
